import * as yup from "yup";
import { TFunction } from "react-i18next";

// Validation for Settings Page fields
const settingValidationSchema = (translation: TFunction) =>
  yup.object().shape({
    consumableCost: yup
      .string()
      .required(translation("consumablecost_requied"))
      .matches(
        /^\d+(\.\d{1,2})?$/,
        translation("max_two_decimals")
      )
      .test(
        "min-value",
        translation("min_qty_not_less_than", { limit: 0 }),
        (value) => {
          if (value === undefined) return true;
          return parseFloat(value) >= 0;
        }
      ),
    markup: yup
      .string()
      .required(translation("markup_requied"))
      .matches(
        /^\d+(\.\d{1,2})?$/,
        translation("max_two_decimals")
      )
      .test(
        "min-value",
        translation("min_qty_not_less_than", { limit: 1 }),
        (value) => {
          if (value === undefined) return true;
          return parseFloat(value) >= 1;
        }
      ),
  });

export default settingValidationSchema;
